const ContactUsIcon3 = (props) => {
	return ( 
		<div>
            <svg width="40" height="27" viewBox="0 0 40 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.1837 0H0.816326C0.365551 0 0 0.365551 0 0.816327V25.3061C0 25.7569 0.365551 26.1225 0.816326 26.1225H39.1837C39.6344 26.1225 40 25.7569 40 25.3061V0.816327C40 0.365551 39.6344 0 39.1837 0ZM36.2184 1.63265L20 11.2947L3.78155 1.63265H36.2184ZM38.3673 24.4898H1.63265V2.25282L13.9434 9.58686L5.20759 16.5028L6.22098 17.7829L15.4443 10.4811L19.5821 12.9462C19.7109 13.0229 19.8554 13.0612 20 13.0612C20.1446 13.0612 20.2891 13.0229 20.4178 12.9462L24.5556 10.4811L33.7789 17.7829L34.7923 16.5028L26.0566 9.58694L38.3673 2.25282V24.4898Z" fill="black"/>
            </svg>
		</div>
	);
}

export default ContactUsIcon3;